"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollapsingNav = exports.ItemsList = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactOutsideClickHandler = _interopRequireDefault(require("react-outside-click-handler"));

var _box = require("../../../components/box");

var _collapsingNav = require("./collapsing-nav.styled");

var _styledComponents = require("styled-components");

var _const = require("./const");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var OpenedStateIcon = function OpenedStateIcon(_ref) {
  var _ref$active = _ref.active,
      active = _ref$active === void 0 ? false : _ref$active,
      _ref$isAem = _ref.isAem,
      isAem = _ref$isAem === void 0 ? false : _ref$isAem;
  return /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavIconsWrapperStyled, {
    active: active,
    "data-test": "block",
    "data-test-id": "collapsing-nav_icon"
  }, isAem ? /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavIconAngleStyled, {
    measure: 14
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavIconPlusStyled, {
    measure: 11
  }), /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavIconMinusStyled, {
    measure: 11
  })));
};

var Target = function Target(_ref2) {
  var headline = _ref2.headline,
      Icon = _ref2.icon,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? 'secondary' : _ref2$color,
      link = _ref2.link,
      active = _ref2.active,
      _ref2$isCollapsingTar = _ref2.isCollapsingTarget,
      isCollapsingTarget = _ref2$isCollapsingTar === void 0 ? false : _ref2$isCollapsingTar,
      _ref2$isAem = _ref2.isAem,
      isAem = _ref2$isAem === void 0 ? false : _ref2$isAem,
      onClick = _ref2.onClick,
      isActiveSection = _ref2.isActiveSection;
  var p = isAem ? [15] : [15, isCollapsingTarget ? 39 : 15];
  return !!headline && /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavTargetStyled, {
    type: "button",
    variant: "solid",
    color: color,
    measure: "sm",
    p: p,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_box.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavHeadingStyled, {
    title: headline,
    isActive: isActiveSection
  }, !!Icon && /*#__PURE__*/_react.default.createElement(Icon, {
    measure: 21,
    mr: 9
  }), /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: headline
    },
    "data-test": "text",
    "data-test-id": "collapsing-nav_sub_section"
  })), /*#__PURE__*/_react.default.createElement(_box.Box, {
    display: "flex",
    alignItems: "center",
    pl: 10
  }, !!link && !isAem && /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavActiveLinkStyled, {
    "data-test": "text",
    "data-test-id": "collapsing-nav_active_link"
  }, link.name), /*#__PURE__*/_react.default.createElement(OpenedStateIcon, {
    active: active,
    isAem: isAem
  }))));
};

var ItemsList = function ItemsList(_ref3) {
  var items = _ref3.items,
      active = _ref3.active,
      isAem = _ref3.isAem,
      isSimple = _ref3.isSimple,
      handleLinkClicked = _ref3.handleLinkClicked,
      routerLink = _ref3.routerLink;

  var _useState = (0, _react.useState)(active),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, items.map(function (_ref4, index) {
    var headline = _ref4.headline,
        icon = _ref4.icon,
        links = _ref4.links;
    var isActive = current === index;
    return /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavLinksBlockStyled, {
      key: index
    }, !isSimple && /*#__PURE__*/_react.default.createElement(Target, {
      headline: headline,
      color: "secondaryLight",
      active: isActive,
      icon: icon,
      isCollapsingTarget: true,
      isAem: isAem,
      onClick: function onClick() {
        return setCurrent(function (prev) {
          return prev !== index ? index : null;
        });
      },
      isActiveSection: isAem && active === index
    }), (isActive || !headline) && /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavLinksListStyled, null, links.map(function (_ref5, index) {
      var name = _ref5.name,
          Icon = _ref5.icon,
          href = _ref5.href,
          handleClick = _ref5.onClick;
      var linkProps = routerLink ? {
        as: routerLink,
        to: href
      } : {
        href: href,
        textDecoration: 'none'
      };
      return /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavLinksListItemStyled, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavAStyled, _extends({}, linkProps, {
        onClick: function onClick() {
          handleClick();
          handleLinkClicked();
        },
        "data-test": "link",
        "data-test-id": "collapsing-nav_link"
      }), !!Icon && /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavLinkIconStyled, null, /*#__PURE__*/_react.default.createElement(Icon, {
        measure: 16,
        mr: 6
      })), name));
    })));
  }));
};

exports.ItemsList = ItemsList;

var CollapsingNav = function CollapsingNav(_ref6) {
  var _ref6$items = _ref6.items,
      items = _ref6$items === void 0 ? [] : _ref6$items,
      _ref6$active = _ref6.active,
      incomingActive = _ref6$active === void 0 ? 0 : _ref6$active,
      _ref6$theme = _ref6.theme,
      navTheme = _ref6$theme === void 0 ? _const.CollapsingNavThemeVariants.DEFAULT : _ref6$theme,
      isAem = _ref6.isAem,
      isSimple = _ref6.isSimple,
      title = _ref6.title,
      routerLink = _ref6.routerLink;

  var _useState3 = (0, _react.useState)(incomingActive),
      _useState4 = _slicedToArray(_useState3, 2),
      active = _useState4[0],
      setActive = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isOpened = _useState6[0],
      setIsOpened = _useState6[1];

  var handleDropdownClosed = function handleDropdownClosed() {
    return setIsOpened(false);
  };

  var toggleDropdownVisibility = function toggleDropdownVisibility() {
    return setIsOpened(function (isVisible) {
      return !isVisible;
    });
  };

  var _ref7 = items.length && items[active] || {},
      _ref7$headline = _ref7.headline,
      headline = _ref7$headline === void 0 ? '' : _ref7$headline,
      _ref7$links = _ref7.links,
      links = _ref7$links === void 0 ? [] : _ref7$links;

  var activeLink = links.find(function (item) {
    return item.isActive;
  });
  (0, _react.useEffect)(function () {
    setActive(incomingActive);
  }, [incomingActive]);
  (0, _react.useEffect)(function () {
    var activeIndex = items.findIndex(function (item) {
      return item.links && item.links.find(function (_ref8) {
        var _ref8$isActive = _ref8.isActive,
            isActive = _ref8$isActive === void 0 ? false : _ref8$isActive;
        return isActive;
      });
    });
    var id = activeIndex !== -1 ? activeIndex : 0;
    setActive(id);
  }, []);
  var theme = {
    $theme: navTheme,
    $isOpened: isOpened,
    $isAem: isAem
  };
  var color = isOpened ? 'secondaryLight' : 'secondary';
  return /*#__PURE__*/_react.default.createElement(_reactOutsideClickHandler.default, {
    onOutsideClick: handleDropdownClosed
  }, /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavStyled, null, /*#__PURE__*/_react.default.createElement(Target, {
    headline: title || headline,
    link: activeLink,
    active: isOpened,
    color: color,
    isAem: isAem,
    onClick: toggleDropdownVisibility
  }), isOpened && /*#__PURE__*/_react.default.createElement(_collapsingNav.CollapsingNavBodyStyled, null, /*#__PURE__*/_react.default.createElement(ItemsList, {
    items: items,
    active: active,
    isAem: isAem,
    isSimple: isSimple,
    handleLinkClicked: handleDropdownClosed,
    routerLink: routerLink
  })))));
};

exports.CollapsingNav = CollapsingNav;
CollapsingNav.defaultProps = {
  items: [],
  active: 0,
  theme: 'default'
};
CollapsingNav.displayName = 'CollapsingNav';
CollapsingNav.Style = _collapsingNav.CollapsingNavStyled;